module.exports = __webpack_public_path__ + "img/books.72e73519.png";